export const EVSE_CONTROLLERS_V1_SEARCH_API_URL = '/1/evse-controllers/search';
export const EVSE_CONTROLLERS_V1_FAST_SEARCH_API_URL =
  '/1/evse-controllers/search/fast';

export const ACCOUNTS_V1_SEARCH_API_URL = '/1/accounts/search';
export const ACCOUNTS_V1_FAST_SEARCH_API_URL = '/1/accounts/search/fast';

export const LOCATIONS_V2_CPO_SEARCH_API_URL = '/2/locations/cpo/search';
export const LOCATIONS_V2_CPO_FAST_SEARCH_API_URL =
  '/2/locations/cpo/search/fast';

export const CHARGING_GROUPS_V1_API_URL = '/1/charging-groups';

export const CHARGING_POLICIES_V1_API_URL = '/1/charging-policies';

export const PAYMENT_TERMINALS_V1_API_URL = '/1/payment-terminals';
export const PAYMENT_TERMINALS_V1_SEARCH_API_URL = `${PAYMENT_TERMINALS_V1_API_URL}/search`;

export const SYSTEM_PAYMENT_TERMINALS_V1_SEARCH_API_URL =
  '/1/system/payment-terminals/search';

export const CUSTOMER_GROUPS_V1_API_URL = '/1/customer-groups';
export const CUSTOMER_GROUPS_V1_SEARCH_API_URL = `${CUSTOMER_GROUPS_V1_API_URL}/search`;
